module.exports = __webpack_public_path__ + "static/media/iron_man_statue.4ec87425.png";